import { Button } from "@/components/Button";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";
import { useMatIntegrationConfiguration } from "@/requests/hooks/mat";
import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons";
import { useParams } from "react-router-dom";

const OnboardingRefetch = (): JSX.Element => {
  const { integration } = useParams();
  const {
    onboardingStatus: { isOnboarding },
  } = useOnboardingStatus();
  const { refetch, isRefetching } = useMatIntegrationConfiguration(
    integration!,
    isOnboarding,
  );

  return (
    <div className="flex flex-row justify-start">
      <Button
        as="button"
        variant="secondary-outline"
        icon={faArrowsRotate}
        iconClassName="mr-5"
        onClick={() => refetch()}
        loading={isRefetching}
        width="lg">
        Refresh
      </Button>
    </div>
  );
};

export default OnboardingRefetch;
